import axios, {AxiosResponse} from 'axios';
import ApiClient from './ApiClient';
import {Registration} from '../types/User/Registration';

export const authService = {
  register,
  authoriseByResponse,
};


function authoriseByResponse(res: AxiosResponse<any>) {
  localStorage.setItem('access_token', res.headers['authorization'].replace('Bearer ', ''));
  let expires = res.headers['expires'];
  localStorage.setItem('expires', String(parseFloat(expires) + new Date().getTime()));
}

function register(formData: Registration, success: (res: AxiosResponse) => void, error: (err: any) => void) {
  axios({
    method: 'POST',
    url: ApiClient.apiDomain + '/registration',
    data: formData,
  }).then(
    (res) => {
      success(res);
    },
    (err) => {
      error(err);
    },
  );
}
